import { cn } from "@/lib/cn";
import { useTranslations } from "next-intl";
import React from "react";

const ContactHeader = ({ title, lang }: { title: string; lang: string }) => {
  const t = useTranslations();

  return (
    <h4
      className={cn(
        lang === "ar" ? "border-r-[3px]" : "border-l-[3px]",
        "text-xl font-semibold my-2 px-4  border-primary"
      )}
    >
      {t(title)}
    </h4>
  );
};

export default ContactHeader;
